var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5048 0C4.71073 0 0 4.48641 0 10.0046C0 15.5228 4.71073 20.0092 10.5048 20.0092C16.2989 20.0092 21.0097 15.5228 21.0097 10.0046C21.0097 4.48641 16.2893 0 10.5048 0ZM18.6882 8.94519H15.4961C15.38 6.75265 14.9157 4.57854 14.1129 2.92953C16.5504 4.06264 18.3109 6.29203 18.6882 8.94519ZM10.5048 17.8812C9.4795 17.8812 7.96085 15.2004 7.73837 11.0548H13.281C13.0585 15.1912 11.5398 17.8812 10.5145 17.8812H10.5048ZM7.7287 8.94519C7.95117 4.80884 9.46983 2.11884 10.4952 2.11884C11.5205 2.11884 13.0392 4.79963 13.2616 8.94519H7.71902H7.7287ZM6.88715 2.92031C6.08429 4.57854 5.61999 6.74344 5.50392 8.93597H2.31184C2.68908 6.28282 4.44956 4.05343 6.88715 2.92031ZM2.31184 11.064H5.50392C5.61999 13.2566 6.08429 15.4307 6.88715 17.0797C4.44956 15.9466 2.68908 13.7172 2.31184 11.064ZM14.1129 17.0797C14.9157 15.4215 15.38 13.2566 15.4961 11.064H18.6882C18.3109 13.7172 16.5504 15.9466 14.1129 17.0797Z",
    fill: "#D1A437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.ef0a4a69f34f8d8efba2a75a3bdbc1c7.svg";
export { ForwardRef as ReactComponent };